import React from 'react'

import css from './style.scss'

const Input = ({ id, type = 'text', autoComplete, input, meta: { touched, error } }) => {
  const inputId = id || input.name
  const hasError = touched && error
  const errorId = inputId ? `${inputId}-error` : undefined
  return (
    <div>
      <input
        id={inputId}
        className={hasError && 'inputError'}
        type={type}
        autoComplete={autoComplete}
        aria-invalid={hasError ? true : undefined}
        aria-describedby={hasError ? errorId : undefined}
        {...input}
      />
      {hasError && <span id={errorId} className={css.errorMessageBox}>{error}</span>}
    </div>
  )
}

export default Input
